import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, dateFormatter } from '../../../components/tables/table'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getNonEmpty } from '../../../../utils/helpers'
import { deleteFeature, getAllActiveFeatures } from '../../../../api/feature'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { shallowEqual, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";

export default function FeaturePage() {
    const [data, setData] = useState([])
    const [refresh, setRefresh] = useState(false)
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const history = useHistory()
    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [feature, setFeature] = useState(null)


    function buttonFormatter(cell) {
        const elem = data.find(item => item._id === cell)
        return (<>
            <Tooltip title="Edit">
                <Button
                    style={buttonsStyle} size="small"
                    onClick={() => history.push('/edit-feature/' + cell)}>
                    <EditIcon />
                </Button>
            </Tooltip>
            {user?.role === "admin" && (
                <>
                    <Tooltip title="Delete">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                setFeature(elem);
                                setOpenConfirmDialog(2);
                            }}
                        >
                            <DeleteIcon />
                        </Button>
                    </Tooltip>
                </>
            )}
        </>)
    }

    const columns = [
        { dataField: 'title', text: 'Title', sort: true },
        {
            dataField: 'createdAt',
            text: 'Created at',
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: '_id', text: '', formatter: buttonFormatter }
    ]

    useEffect(() => {
        getAllActiveFeatures().then((res) => {
            const data = res.data.map(item => ({
                ...item,
                title: getNonEmpty(item.title)
            }))
            setData(data)
            setRefresh(false)
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get features.' })
        })
    }, [refresh])

    return (
        <>
            <Card>
                <CardHeader title='Features list'>
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-feature")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table
                        data={data}
                        columns={columns}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this feature?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteFeature(feature._id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Feature plan deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the feature.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}
